import { render, staticRenderFns } from "./ProfileEditDialog.vue?vue&type=template&id=b021dd12"
import script from "./ProfileEditDialog.vue?vue&type=script&lang=js"
export * from "./ProfileEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports